import React from 'react';

const BedSvg = (props) => {
    return (
    <svg xmlns="http://www.w3.org/2000/svg" width={props.width || 20} height={props.height || 20} viewBox="0 0 67 76" className={props.clazz || ""}>
        <g fill={props.fill || ""}>
            <g>
            <path d="M28.0918 8.81a2 2 0 0 1-1.3457-3.48L32.041.52a1.9983 1.9983 0 0 1 2.6582-.0277l5.4365 4.7334a2 2 0 1 1-2.627 3.0166l-4.0946-3.5654L29.4355 8.29a1.9909 1.9909 0 0 1-1.3437.52zM65 76.6036H2a2 2 0 0 1-2-2V33.2823a9.9876 9.9876 0 0 1 3.4922-7.5918l17.0439-14.61a2 2 0 1 1 2.6039 3.0368L6.0957 28.7276A5.9889 5.9889 0 0 0 4 33.2823v39.3213h59v-39.33a5.9973 5.9973 0 0 0-2.0869-4.5488L43.9375 14.1163a2 2 0 0 1 2.6094-3.0317l16.9756 14.6089A9.9927 9.9927 0 0 1 67 33.2735v41.33a2 2 0 0 1-2 2.0001z"/>
            <path d="M12.1836 71.6095a2 2 0 0 1-2-2v-22.5a2 2 0 0 1 4 0v22.5a2 2 0 0 1-2 2zM54.8154 71.6095a2 2 0 0 1-2-2V53.6232a2 2 0 0 1 4 0v15.9863a2 2 0 0 1-2 2z"/>
            <path d="M54.8154 66.2814H12.1836a2 2 0 0 1-2-2v-5.3291a2 2 0 0 1 2-2h42.6318a2 2 0 0 1 2 2v5.3291a2 2 0 0 1-2 2zm-40.6318-4h38.6318v-1.3291H14.1836z"/>
            <path d="M26.1973 60.9523H12.1836a2 2 0 0 1 0-4h10.2451c-1.1836-.9189-3.0957-1.3291-7.123-1.3291h-3.1221a2 2 0 0 1 0-4h3.1221c8.5293 0 10.4932 2.0605 12.6807 6.4346a2 2 0 0 1-1.7891 2.8945z"/>
            </g>
        </g>
    </svg>
    )
}

export default React.memo(BedSvg);




